import { render, staticRenderFns } from "./parts_items.vue?vue&type=template&id=d45e7348&scoped=true&"
import script from "./parts_items.vue?vue&type=script&lang=js&"
export * from "./parts_items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45e7348",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d45e7348')) {
      api.createRecord('d45e7348', component.options)
    } else {
      api.reload('d45e7348', component.options)
    }
    module.hot.accept("./parts_items.vue?vue&type=template&id=d45e7348&scoped=true&", function () {
      api.rerender('d45e7348', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/create/mem_preview/addon/parts/adv/parts_items.vue"
export default component.exports